const returnStringValueForSelect = (initValue: { value: number, label: string } | string | number | null | undefined): string => {
	if(!initValue)
		return "";
	if(typeof initValue === "object" && initValue?.value)
		return initValue?.value?.toString();
	if(typeof initValue === "number")
		return initValue?.toString();
	if(typeof initValue === "string")
		return initValue;
	return "";
};

export default returnStringValueForSelect;
